export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bastabet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bastabet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
